export default __webpack_public_path__ + "static/media/instagram.75e0546a.png";